import React, { useState } from 'react';
import { Content, Row, Col, Title, Text, Table } from 'components';
import { SideMenu } from '../components';
import OrderItem from '../components/OrderItem/OrderItem';
import Product from 'assets/product_01.png';
import moment from 'moment';

const PAGE_NUM = [
  { label: '5개씩', value: 5 },
  { label: '10개씩', value: 10 },
  { label: '15개씩', value: 15 },
  { label: '20개씩', value: 20 },
];

/* 재입고 알림 내역 */
const restockList = [
  {
    created_at: new Date(),
    product_name: '시그니처블랜드 617th 에비뉴 200g',
    place_name: 'JMCOFFEE',
    product_data: '분쇄안함 / 200g / 10개',
    src: Product,
    type: 'active', // "active" = 알림 해제와 삭제 버튼 표시
  },
  {
    created_at: new Date(),
    product_name: '시그니처블랜드 617th 에비뉴 200g',
    place_name: 'JMCOFFEE',
    product_data: '분쇄안함 / 200g / 10개',
    src: Product,
    type: 'inactive', // "inactive" = 알림 재신청 버튼 표시
  },
];

const MypageRestockPresenter = (props) => {
  /* ===== Props ===== */
  const { screenSize } = props;

  const styles = {
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 24,
      borderBottom: '2px solid var(--black-color)',
    },
    title: {
      fontSize: screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
      fontWeight: 700,
      color: 'var(--black-color)',
    },
  };

  return (
    <Content
      maxWidth={1820}
      padding={screenSize >= 768 ? '120px 0px' : '60px 0'}
    >
      <Row gutter={25}>
        <Col x={0} md={1} xl={2}></Col>
        <Col x={0} md={6} xl={4}>
          <SideMenu />
        </Col>
        <Col x={24} md={16} xl={16}>
          <Content
            maxWidth={'100%'}
            padding={
              screenSize >= 1200
                ? '0 0 0 95px'
                : screenSize >= 768
                ? '0 0 0 20px'
                : '0'
            }
          >
            <div style={{ ...styles.titleLayout }}>
              <Title style={{ ...styles.title }}>재입고 알림 신청 내역</Title>
            </div>
            {/* 재입고 알림 내역 */}
            <Table
              data={restockList}
              pagination={false}
              columns={[
                {
                  key: 'created_at',
                  render: (item) => moment(item).format('YYYY.MM.DD'),
                  style: {
                    fontSize: 16,
                    width: '15%',
                  },
                },
                {
                  key: 'product_name',
                  render: (item, record) => (
                    <OrderItem
                      placeName={record.place_name}
                      productName={item}
                      src={record.src}
                      productData={record.product_data}
                    />
                  ),
                  style: {
                    width: '55%',
                    padding: '32px 0',
                  },
                },
                {
                  key: 'actions',
                  render: (item, record) => {
                    if (record.type === 'active') {
                      return (
                        <div style={{ display: 'flex', gap: 24 }}>
                          <span
                            style={{
                              fontSize: 16,
                              fontWeight: 700,
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              border: '1px solid var(--black-color)',
                              borderRadius: 4,
                              width: 180,
                              height: 48,
                            }}
                            onClick={() =>
                              alert(`알림 해제 for ${record.product_name}`)
                            }
                          >
                            알림 해제
                          </span>
                          <span
                            style={{
                              fontSize: 16,
                              fontWeight: 700,
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              border: '1px solid var(--black-color)',
                              borderRadius: 4,
                              width: 180,
                              height: 48,
                            }}
                            onClick={() =>
                              alert(`삭제 for ${record.product_name}`)
                            }
                          >
                            삭제
                          </span>
                        </div>
                      );
                    } else if (record.type === 'inactive') {
                      return (
                        <span
                          style={{
                            fontSize: 16,
                            fontWeight: 700,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1px solid var(--black-color)',
                            borderRadius: 4,
                            width: 386,
                            height: 48,
                          }}
                          onClick={() =>
                            alert(`알림 재신청 for ${record.product_name}`)
                          }
                        >
                          알림 재신청
                        </span>
                      );
                    }
                  },
                  style: {
                    fontSize: 16,
                    width: '30%',
                    textAlign: 'center',
                  },
                },
              ]}
              headerStyle={{
                display: 'none',
              }}
              bordered={false}
              hovered={false}
              minHeight={restockList.length ? 'auto' : 200}
            />
            {/* 재입고 알림 내역 끝 */}
          </Content>
        </Col>
        <Col x={0} md={1} xl={2}></Col>
      </Row>
    </Content>
  );
};

export default MypageRestockPresenter;
